import {useContext} from 'react'

import {SlotManagementContext} from './SlotManagementContext'

/**
 * Hook to access slot management state from context.
 *
 * Provides access to:
 * - `slotAvailabilities`: Array of slot availability states for each dateTime in the form
 * - `setSlotAvailability`: Function to update availability for a specific slot
 * - `setSlotAvailabilities`: Function to batch update all slot availabilities
 *
 * @throws Error if used outside of SlotManagementContext.Provider
 *
 * @example
 * ```tsx
 * const { slotAvailabilities, setSlotAvailability } = useSlotManagementContext()
 *
 * // Update by dateTime
 * setSlotAvailability({
 *   dateTime: '2025-10-28T10:00:00Z',
 *   isAvailable: true
 * })
 *
 * // Update by index
 * setSlotAvailability({
 *   dateTimeIndex: 0,
 *   isAvailable: true
 * })
 * ```
 */
export const useSlotManagementContext = () => {
  const context = useContext(SlotManagementContext)

  if (!context) {
    throw new Error('useSlotManagementContext must be used within a SlotManagementContext.Provider')
  }

  return context
}
